module.exports = __webpack_public_path__ + "static/img/002城市名片2.c9d9f0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/002城市名片2.jpg
// module id = Zgo7
// module chunks = 0